function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		throw new Error("Cannot find module '" + req + "'.");
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./SignClient/$$_lazy_route_resource lazy recursive";


//////////////////
// WEBPACK FOOTER
// ./SignClient/$$_lazy_route_resource lazy
// module id = ./SignClient/$$_lazy_route_resource lazy recursive
// module chunks = main